import React , {useEffect, useState, useRef} from 'react';
import { useNavigate, Link } from "react-router-dom";
import '../assets/css/animate.css';
import '../assets/css/font-awesome.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faLock, faRefresh } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faGooglePlusG } from '@fortawesome/free-brands-svg-icons';
import curonext from '../assets/img/CuronextFinal.png';
import '../assets/css/bootstrap.min.css';  
import {commonAPI} from "../services/CommonAPIService"
import {ErrorSource} from '../common/constants' 
import {EmailOTPTeamName} from '../common/constants' 
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../assets/css/login.css';
import { Button } from 'react-bootstrap';
 

  function Login() {
    const history = useNavigate();
    const [Loading, setLoading] = useState(false);
    const [ForgotShow, setForgotShow] = useState(false);
    const [EmailPhone, setEmailPhone] = useState("");
    const [ForgotEmailPhone, setForgotEmailPhone] = useState("");
    const [ProductFactor, setProductFactor] = useState("");
    const [Password, setPassword] = useState("");
    const [Disable, setDisable] = useState(true);
    const [DisableOTP, setDisableOTP] = useState(true);
    const [DisableOTPMatch, setDisableOTPMatch] = useState(true);
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [resendButtonDisableTime, setResendButtonDisableTime] = useState(20); // 20 seconds
    const [ShowHide, setShowHide] = useState(false);
    const [captcha, setCaptcha] = useState('');
    const [captchaInput, setCaptchaInput] = useState('');
    const [isCaptchaValid, setIsCaptchaValid] = useState(true);
    const [OTPMatch, setOTPMatch] = useState(true);
    const [OTP, setOTP] = useState("");
    const [ProductName, setProductName] = useState("");
    const [OTPShow, setOTPShow] = useState(true);
    const [OTPgentime, setOTPgentime] = useState();
    const [OTPType, setOTPType] = useState();
    const canvasRef = useRef(null);
   

    const generateCaptcha = () => {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let captcha = '';
        for (let i = 0; i < 6; i++) {
          captcha += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return captcha;
    };

    useEffect(() => {
        const newCaptcha = generateCaptcha();
        setCaptcha(newCaptcha);
        drawCaptcha(newCaptcha);
      }, [ForgotShow]);

      const drawCaptcha = (captchaCode) => {
        const canvas = canvasRef?.current;
        if (!canvas || !captchaCode) return; // Check if canvas or captchaCode is null/undefined
    
        const ctx = canvas.getContext('2d');
        if (!ctx) return; // Ensure context is available
    
        // Clear canvas and draw new CAPTCHA
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.font = '30px Arial';
        ctx.fillStyle = '#000';
        ctx.fillText(captchaCode, 10, 25);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
    
        if (captchaInput === captcha) {
          alert('Captcha Validated Successfully!');
          // Perform the form submission or API call here
        } else {
          setIsCaptchaValid(false);
        }
      };

    const handleRefreshCaptcha = () => {
        const newCaptcha = generateCaptcha();
        setCaptcha(newCaptcha);
        drawCaptcha(newCaptcha);
        setCaptchaInput('');
        setIsCaptchaValid(true);
    };

    const ProductApi = async () => {
        try {
            setLoading(true);
            let response = await commonAPI("CuroProducts")
            if (response.success===true){
                // console.log("Table", response)
                const productName = response.data.filter((products, index) => {
                    return products.productName.toUpperCase() === "CURONEXT"
                  })
                  
                  localStorage.setItem('primeProductCode', JSON.stringify( {primeProductCode:productName[0]?.primeProductCode}));
                  setProductFactor(productName[0].primeProductCode)
                  setProductName(productName[0].productName)
                //   console.log(productName[0].primeProductCode)
                setLoading(false);
            }else{
                toast.error("Something went wrong");
                // alert("Something went wrong");
                setLoading(false);
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = JSON.stringify({ 
                "userId": "", // Need to be change
                "mobileNumber": "", // Need to be change
                "requestJSON": "",
                "uri": "/api/Common/CuroProducts",
                "errorNumber": "CP01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Login.js",
                "functionName": "ProductApi",
            });
            let response = await commonAPI("ErrorLogMaster", bodyError)
           
            if(response.success === true && response.message.length == 0){
                toast.error("Something went wrong");
                setLoading(false); 
            }else{
                toast.error("Something went wrong");
                setLoading(false); 
            }
            
        }

    }

    useEffect(() => {
        ProductApi();
    }, [])

    useEffect(() => {
        if (
            (EmailPhone.length > 9 || EmailPhone.includes("@")) &&
            Password.length !== 0 &&
            captchaInput  // Add CAPTCHA validation
        ) {
            setDisable(false); // Enable the button only if CAPTCHA matches
        } else {
            setDisable(true);  // Disable the button otherwise
        }
    }, [EmailPhone, Password, captchaInput]);

    // useEffect(() => {
    //     if((EmailPhone.length > 9 || EmailPhone.includes("@")) && Password.length != 0){
    //         setDisable(false);
    //     }else{
    //         setDisable(true);
    //     }
    // }, [EmailPhone,Password])

    // useEffect(() => {
    //     if(OTP.length > 5){
    //         setDisableOTP(false);
    //     }else{
    //         setDisableOTP(true);
    //     }
    // }, [OTP])


    const LoginApi = async () => {
        const bodydata = { 
            "userId": EmailPhone,
            "userPassword": Password
        };
        try {
            if (!navigator.onLine) {
              toast.warning("You are offline. Please check your internet connection.");
              return;
            }
            const userDataString = localStorage.getItem("primeProductCode");
            const PrimeProductCode = JSON.parse(userDataString);
      
            if (!EmailPhone) {
              toast.warning("Please Enter Email / Mobile No");
              return;
            }

            else if (!captchaInput) {
                toast.warning("Please Enter Captcha code");
                return;
              }
      
            // Validate CAPTCHA before proceeding with API call
            else if (captchaInput !== captcha) {
              setIsCaptchaValid(false);
              toast.error("Invalid CAPTCHA. Please try again.");
              return;
            }else{
                // let tokenResponse = await commonAPI("Token", bodydata);
                let response = await commonAPI("Login", bodydata)
                
                // console.log("this is the response", tokenResponse)
                // if(tokenResponse && Object.keys(tokenResponse).length && tokenResponse.success && tokenResponse.data?.token){
                //     localStorage.setItem("token", JSON.stringify({token: tokenResponse?.data?.token, validUpTo: (new Date().getTime()) + tokenResponse?.data?.expiresInSeconds * 1000 }) )
                     
                    // const claims = decodeJwt(tokenResponse?.data?.token);
                    console.log("Login Response", response)
                    if(response?.success == true && response?.message.length == 0){
                        // setLoginData(response?.data) ;
                            const bodyData = { 
                                "userId": response?.data?.userId,
                                "userImageRequired": true,
                                "buildingLogoRequired": true
                              };
                            // if (EmailPhone.includes("@")){
                                let responseMapping = await commonAPI("GetCuroNextUserMapping", bodyData)
                
                                // console.log("Login Response", response)
                                if(responseMapping?.success == true && responseMapping?.message.length == 0){
                                    // alert("User Added"); 
                                    // console.log("Portal Login", response)
                                    console.log("responseMapping",responseMapping)
                                    if(responseMapping?.data?.length > 1){
                                    // if(responseMapping?.data?.length == 1){    
                                        const dataToUpdate = {
                                            ...response?.data,
                                            loginCount : 1,
                                        }
                                        localStorage.setItem("userData", JSON.stringify(dataToUpdate))
                                        history('/SelectBuilding');
                                    }else if (responseMapping?.data?.length == 1 && responseMapping?.data[0]?.currentStatus.toUpperCase() == "APPROVED"){
                                        console.log("Approved", responseMapping)
                                        if(responseMapping?.data[0]?.roleName == "Support Admin"){
                                            if (!responseMapping?.data[0].isActive && !responseMapping?.data[0]?.isActiveUser){
                                                toast.error("Your account is inactive");
                                            }else if (!responseMapping?.data[0]?.isActiveBuilding){
                                                toast.error("Your building is inactive");
                                            }else if (!responseMapping?.data[0]?.isActiveClient){
                                                toast.error("Your client is inactive");
                                            }else{
                                                const dataToUpdate = {
                                                    // ...response?.data,
                                                    loginCount : 1,
                                                    // loginMessage : 1,
                                                    userImage: responseMapping?.data[0]?.userImage,
                                                    userId: responseMapping?.data[0]?.userId,
                                                    userName: responseMapping?.data[0]?.userName,
                                                    mobileNumber: responseMapping?.data[0]?.mobileNumber,
                                                    emailId: responseMapping?.data[0]?.emailId,
                                                    productAccessFactor: responseMapping?.data[0]?.productAccessFactor,
                                                    familyGroupId: responseMapping?.data[0]?.familyGroupId,
                                                    userMappingId: responseMapping?.data[0]?.userMappingId,
                                                    buildingId: responseMapping?.data[0]?.buildingId,
                                                    buildingName: responseMapping?.data[0]?.buildingName,
                                                    flatId: responseMapping?.data[0]?.flatId,
                                                    flatName: responseMapping?.data[0]?.flatName,
                                                    roleId: responseMapping?.data[0]?.roleId,
                                                    roleName: responseMapping?.data[0]?.roleName,
                                                    IsParent: responseMapping?.data[0]?.IsParent,
                                                    currentStatus: responseMapping?.data[0]?.currentStatus,
                                                    familyGroupId: responseMapping?.data[0]?.familyGroupId,
                                                    isActiveBuilding: responseMapping?.data[0]?.isActiveBuilding,
                                                    isActiveClient: responseMapping?.data[0]?.isActiveClient,
                                                    isActiveRole: responseMapping?.data[0]?.isActiveRole,
                                                    isActiveUser: responseMapping?.data[0]?.isActiveUser,
                                                    isActive: responseMapping?.data[0]?.isActive,
                                                    logo: responseMapping?.data[0]?.logo,
                                                    addressLine1: responseMapping?.data[0]?.addressLine1,
                                                    addressLine2: responseMapping?.data[0]?.addressLine2,
                                                    city: responseMapping?.data[0]?.city,
                                                    state: responseMapping?.data[0]?.state
                                                }
                                                console.log("dataToUpdate1111", dataToUpdate);
                                                console.log("data Mapping", responseMapping);
                                                localStorage.setItem("userData", JSON.stringify(dataToUpdate))
                                                // toast.success("Login Successfully");
                                                
                                                history('/Dashboard');
                                                
                                            }
                                        }else if(responseMapping?.data[0]?.roleName == "Society HelpDesk") {
                                            if (!responseMapping?.data[0]?.isActive && !responseMapping?.data[0]?.isActiveUser){
                                                toast.error("Your account is inactive");
                                            }else if (!responseMapping?.data[0]?.isActiveBuilding){
                                                toast.error("Your building is inactive");
                                            }else if (!responseMapping?.data[0]?.isActiveClient){
                                                toast.error("Your client is inactive");
                                            }else{
                                                ProductApi();
                                                const dataToUpdate = {
                                                    // ...response?.data,
                                                    loginCount : 1,
                                                    // loginMessage : 1,
                                                    userImage: responseMapping?.data[0]?.userImage,
                                                    userId: responseMapping?.data[0]?.userId,
                                                    userName: responseMapping?.data[0]?.userName,
                                                    mobileNumber: responseMapping?.data[0]?.mobileNumber,
                                                    emailId: responseMapping?.data[0]?.emailId,
                                                    productAccessFactor: responseMapping?.data[0]?.productAccessFactor,
                                                    familyGroupId: responseMapping?.data[0]?.familyGroupId,
                                                    userMappingId: responseMapping?.data[0]?.userMappingId,
                                                    buildingId: responseMapping?.data[0]?.buildingId,
                                                    buildingName: responseMapping?.data[0]?.buildingName,
                                                    flatId: responseMapping?.data[0]?.flatId,
                                                    flatName: responseMapping?.data[0]?.flatName,
                                                    roleId: responseMapping?.data[0]?.roleId,
                                                    roleName: responseMapping?.data[0]?.roleName,
                                                    IsParent: responseMapping?.data[0]?.IsParent,
                                                    currentStatus: responseMapping?.data[0]?.currentStatus,
                                                    familyGroupId: responseMapping?.data[0]?.familyGroupId,
                                                    isActiveBuilding: responseMapping?.data[0]?.isActiveBuilding,
                                                    isActiveClient: responseMapping?.data[0]?.isActiveClient,
                                                    isActiveRole: responseMapping?.data[0]?.isActiveRole,
                                                    isActiveUser: responseMapping?.data[0]?.isActiveUser,
                                                    isActive: responseMapping?.data[0]?.isActive,
                                                    logo: responseMapping?.data[0]?.logo,
                                                    addressLine1: responseMapping?.data[0]?.addressLine1,
                                                    addressLine2: responseMapping?.data[0]?.addressLine2,
                                                    city: responseMapping?.data[0]?.city,
                                                    state: responseMapping?.data[0]?.state
                                                }
                                                console.log("dataToUpdate2222", dataToUpdate);
                                                console.log("data Mapping", responseMapping);
                                                localStorage.setItem("userData", JSON.stringify(dataToUpdate))
                                                // toast.success("Login Successfully");
                                                history('/ComplaintDashboard');
    
                                            }
                                        }else{
                                            if (!responseMapping?.data[0]?.isActive && !responseMapping?.data[0]?.isActiveUser){
                                                toast.error("Your account is inactive");
                                            }else if (!responseMapping?.data[0]?.isActiveBuilding){
                                                toast.error("Your building is inactive");
                                            }else if (!responseMapping?.data[0]?.isActiveClient){
                                                toast.error("Your client is inactive");
                                            }else{
                                                ProductApi();
                                                const dataToUpdate = {
                                                    // ...response?.data,
                                                    loginCount : 1,
                                                    // loginMessage : 1,
                                                    userImage: responseMapping?.data[0]?.userImage,
                                                    userId: responseMapping?.data[0]?.userId,
                                                    userName: responseMapping?.data[0]?.userName,
                                                    mobileNumber: responseMapping?.data[0]?.mobileNumber,
                                                    emailId: responseMapping?.data[0]?.emailId,
                                                    productAccessFactor: responseMapping?.data[0]?.productAccessFactor,
                                                    familyGroupId: responseMapping?.data[0]?.familyGroupId,
                                                    userMappingId: responseMapping?.data[0]?.userMappingId,
                                                    buildingId: responseMapping?.data[0]?.buildingId,
                                                    buildingName: responseMapping?.data[0]?.buildingName,
                                                    flatId: responseMapping?.data[0]?.flatId,
                                                    flatName: responseMapping?.data[0]?.flatName,
                                                    roleId: responseMapping?.data[0]?.roleId,
                                                    roleName: responseMapping?.data[0]?.roleName,
                                                    IsParent: responseMapping?.data[0]?.IsParent,
                                                    currentStatus: responseMapping?.data[0]?.currentStatus,
                                                    familyGroupId: responseMapping?.data[0]?.familyGroupId,
                                                    isActiveBuilding: responseMapping?.data[0]?.isActiveBuilding,
                                                    isActiveClient: responseMapping?.data[0]?.isActiveClient,
                                                    isActiveRole: responseMapping?.data[0]?.isActiveRole,
                                                    isActiveUser: responseMapping?.data[0]?.isActiveUser,
                                                    isActive: responseMapping?.data[0]?.isActive,
                                                    logo: responseMapping?.data[0]?.logo,
                                                    addressLine1: responseMapping?.data[0]?.addressLine1,
                                                    addressLine2: responseMapping?.data[0]?.addressLine2,
                                                    city: responseMapping?.data[0]?.city,
                                                    state: responseMapping?.data[0]?.state
                                                }
                                                console.log("dataToUpdate2222", dataToUpdate);
                                                console.log("data Mapping", responseMapping);
                                                localStorage.setItem("userData", JSON.stringify(dataToUpdate))
                                                // toast.success("Login Successfully");
                                                history('/Dashboard');
                                            }    
                                        }
                                        
                                    }else{
                                        // console.log("NotApproved", responseMapping)
                                        // toast.warning(response?.message[0]);
                                        toast.error("Your status is pending");
                                    }
                                }else{
                                    toast.error(responseMapping.message[0]);
                                }
                                // console.log("this is email")
                            // }else{
                            //     MobileOtpApi();
                            //     setShowHide(true);
                            //     // console.log("this is Mobile number");
                            // }
                        
                        // setShowHide(false)
                    }else{
                        // alert(response.message[0]);
                        console.log("Login Response", response)
                        toast.error(response.message[0]);
                        setShowHide(false);
                    }
                // }else if(tokenResponse  && !tokenResponse.success){
                //     toast.error(tokenResponse.message[0]);
                //     setShowHide(false);
                // }else{
                //     console.log("Reponse error", tokenResponse)
                //     toast.error("Something went wrong");
                //     setShowHide(false);
                // }

                
            }    
            
      
        } catch (error) {
            setLoading(false);
            const bodyError = JSON.stringify({ 
                "userId": "", // Need to be change
                "mobileNumber": EmailPhone, // Need to be change
                "requestJSON": bodydata,
                "uri": "/api/Master/Notice",
                "errorNumber": "LG01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "Login.js",
                "functionName": "LoginApi",
            });
            console.log("body",bodyError)
            let response = await commonAPI("ErrorLogMaster", bodyError)
            
           console.log(response)
            if(response?.success === true && response?.message.length == 0){
                // alert("Something went wrong");
                toast.error("Something went wrong");
                setLoading(false); 
            }else{
                toast.error("Something went wrong");
                setLoading(false); 
            }
        }
        
          
          
    }

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (!Disable) {
                if (event.key === 'Enter') {
                    event.preventDefault();  // Prevent default form submission behavior
                    LoginApi();  // Call Login function
                }
            }    
        };
    
        // Attach the event listener
        window.addEventListener('keydown', handleKeyDown);
    
        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [EmailPhone, Password, captchaInput])

    useEffect(() => {
        const storedUsername = localStorage.getItem('userData');
        console.log("useEffect Local storage name", storedUsername)
        if (storedUsername) {
          // If the username is present, redirect to the dashboard
          history('/Dashboard');
          console.log("useEffect Local storage Yes")    
        }
        else if(storedUsername===null){
            history('/');
            console.log("useEffect Local storage No")    
        }
    }, [history]);

    const ForgotPassword = async () => {
        try {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email validation regex
        const mobileRegex = /^\d{10}$/; // Assuming a 10-digit mobile number format
    
          if (!ForgotEmailPhone) {
              toast.warning("Please enter Email/Mobile Number");
              return;
          }
          if (!emailRegex.test(ForgotEmailPhone) && !mobileRegex.test(ForgotEmailPhone)) {
            toast.warning("Please enter a valid Email or Mobile Number");
            return;
          }
          let isEmail = emailRegex.test(ForgotEmailPhone);
          let isMobile = mobileRegex.test(ForgotEmailPhone); 

          setLoading(true);
          const bodydata = { 
            appName: ProductName,
            ...(isEmail ? { emailId: ForgotEmailPhone } : { mobileNumber: ForgotEmailPhone })
          };

          
          let response = await commonAPI("ForgotPassword", bodydata);
          console.log("Response ForgotPassword", response, bodydata)
          if (response?.success == true && response?.message.length == 0) {
            if(OTPType  == "MOBILE"){
                toast.success("Password sent to your Mobile Number");
            }else{
                toast.success("Password sent to your Email");
            }
            setLoading(false);
            setForgotShow(false);
            setOTPShow(true);
            generateCaptcha();
            handleRefreshCaptcha();
          } else {
            toast.error(response.message[0]);
            setLoading(false);
          }
         
        } catch (error) {
          setLoading(false);
          const bodyError = { 
            "userId": ForgotEmailPhone,
            "mobileNumber": ForgotEmailPhone,
            "requestJSON": null,
            "uri": "/api/User/UserImage",
            "errorNumber": "PU01",
            "errorSource": "CuroNextPortal",
            "errorSummary": error.message,
            "errorDescription": error.message,
            "fileClassName": "Profile.js",
            "functionName": "UpdateImage",
          };
          let response = await commonAPI("ErrorLogMaster", bodyError);
          if (response.success === true && response.message.length === 0) {
            toast.error("Something went wrong");
          } else {
            toast.error("Something went wrong");
          }
        }
    };

    const MobileOtpApi = async () => {
        const bodydata = { 
            "templateKey": "OTP",
            "smsTo": ForgotEmailPhone,
            "appSource": "CuroNext",
            "placeHolderList": {
                "{#appname#}": "CuroNext",
                "{#otp#}": ""
            }
        };
        try {
            if(!ForgotEmailPhone){
                toast.warning("Please enter mobile number");
                // alert("Please enter mobile number");
            }else{
                // console.log("body", bodydata);
                let response = await commonAPI("MobileOTP", bodydata)
                console.log("otp response", response.data);
                if(response.success == true & response.message.length == 0){
                    // alert("OTP sent to your mobile number");  
                    toast.success("OTP sent to your mobile number");
                    setOTPMatch(response.data)
                    setOTPgentime(Date.now())
                    setOTPShow(false)
                    setShowHide(true)
                }else{
                    toast.error(response.message[0]);
                    setShowHide(false)
                }
            }
            
        } catch (error) {
            setLoading(false);
            const bodyError = { 
                "errorLogId": 0, // Need to be change
                "userId": 2, // Need to be change
                "mobileNumber": "", 
                "requestJSON": bodydata,
                "uri": "/api/Notification/MobileOTP",
                "errorNumber": "POTP01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Registration.js",
                "functionName": "OtpApi",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError)
           
            if(response.success === true && response.message.length == 0){
                toast.error("Something went wrong");
                setLoading(false); 
            }else{
                toast.error("Something went wrong");
                setLoading(false); 
            }
        }
        
          
          
    }

    const EmailOtpApi = async () => {
        const bodydata = { 
            "templateKey": "OTP",
            "emailTo": ForgotEmailPhone,
            "appSource": "CuroNext",
            "placeHolderList": {
                "{#appname#}": "CuroNext",
                "{#username#}": ForgotEmailPhone,
                "{#otp#}": "",
                "{#useremailid#}": ForgotEmailPhone,
                "{#supportteamName#}" : EmailOTPTeamName
            }
        };
        try {
            if(!ForgotEmailPhone){
                toast.warning("Please enter mobile number");
            }else{
                let response = await commonAPI("EmailOTP", bodydata)
                if(response.success == true & response.message.length == 0){
                    toast.success("OTP sent to your registered email")
                    setOTPMatch(response.data)
                    setOTPgentime(Date.now())
                    setOTPShow(false)
                    setShowHide(true)
                }else{
                    toast.error(response.message[0]);
                    // alert(response.message[0]);
                    setShowHide(false)
                }
            }
            
        } catch (error) {
            setLoading(false);
            const bodyError = { 
                "errorLogId": 0, // Need to be change
                "userId": 2, // Need to be change
                "mobileNumber": "", 
                "requestJSON": bodydata,
                "uri": "/api/Notification/EmailOTP",
                "errorNumber": "EOTP01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "Registration.js",
                "functionName": "EmailOtpApi",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError)
           
            if(response.success === true && response.message.length == 0){
                toast.error("Something went wrong");
                setLoading(false); 
            }else{
                toast.error("Something went wrong");
                setLoading(false); 
            }
        }
        
          
          
    }

    const handleSendOtp = async () => {
        if (!ForgotEmailPhone) {
            toast.warning("Please enter Email/Mobile Number");
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email validation regex
        const mobileRegex = /^\d{10}$/; // Assuming a 10-digit mobile number format

        const isEmail = emailRegex.test(ForgotEmailPhone);
        const isMobile = mobileRegex.test(ForgotEmailPhone);

        if (!isEmail && !isMobile) {
            toast.warning("Please enter a valid Email or Mobile Number");
            return;
        }

        try {
            if (isEmail) {
                EmailOtpApi();
                setOTPType("EMAIL")
                setDisableOTP(true)
                // toast.success("OTP sent to your email");
            } else if (isMobile) {
                MobileOtpApi();
                setOTPType("MOBILE")
                setDisableOTP(true)
                // toast.success("OTP sent to your mobile");
            }
            setIsButtonDisabled(true);
            startResendOtpTimer();
        } catch (error) {
            toast.error("An error occurred while sending OTP");
            console.error("Error sending OTP:", error);
        }
    }

    const startResendOtpTimer = () => {
        setResendButtonDisableTime(20); // Reset timer to 20 seconds
        setIsButtonDisabled(true); // Disable the button

        const timer = setInterval(() => {
            setResendButtonDisableTime(prevTime => {
                if (prevTime <= 1) {
                    clearInterval(timer);
                    setIsButtonDisabled(false); // Enable button after 20 seconds
                    return 0;
                }
                return prevTime - 1; // Decrement timer
            });
        }, 1000); // Update every second
    };


    const matchOTP = async () => {
        try {
            console.log("OTP", OTPMatch, OTP);
            
            // Calculate the time difference in minutes
            const currentTime = Date.now();
            const timeDifference = (currentTime - OTPgentime) / (1000 * 60); // Convert to minutes
            console.log("timeDifference", timeDifference, OTPgentime, currentTime);
            if (OTPMatch == OTP) {
                if (timeDifference <= 10) { // Check if the OTP is within 10 minutes
                    setShowHide(false);
                    console.log("OTP verified successfully");
                    ForgotPassword();                    
                    return;
                } else {
                    toast.error("OTP has expired. Please request a new one.");
                    setShowHide(true);
                }
            } else {
                toast.error("Please enter a valid OTP");
                setShowHide(true);
            }
        } catch (error) {
            console.error("Error in OTP verification:", error);
        }
    };

    useEffect(() => {
        if (
            (ForgotEmailPhone.length > 9 || ForgotEmailPhone.includes("@"))
        ) {
            setDisableOTP(false); // Enable the button only if CAPTCHA matches
        } else {
            setDisableOTP(true);  // Disable the button otherwise
        }
    }, [ForgotEmailPhone]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (!DisableOTP) {
                if (event.key === 'Enter') {
                    event.preventDefault();  // Prevent default form submission behavior
                    handleSendOtp();  // Call Login function
                }
            }    
        };
    
        // Attach the event listener
        window.addEventListener('keydown', handleKeyDown);
    
        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [ForgotEmailPhone, DisableOTP])

    useEffect(() => {
        if (
            (OTP.length > 5)
        ) {
            setDisableOTPMatch(false); // Enable the button only if CAPTCHA matches
        } else {
            setDisableOTPMatch(true);  // Disable the button otherwise
        }
    }, [OTP]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (!DisableOTPMatch) {
                if (event.key === 'Enter') {
                    event.preventDefault();  // Prevent default form submission behavior
                    matchOTP();  // Call Login function
                }
            }    
        };
    
        // Attach the event listener
        window.addEventListener('keydown', handleKeyDown);
    
        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [OTP, DisableOTPMatch])

    return ( 
             <>
               {Loading? 
                    <div className="loaderDiv" style={{top: 0}}>
                        <div className="loader" ></div>
                    </div> 
                :null}
               <div className="login-register">

                <ToastContainer />
                
                    <div className='container'>
                        <div className='row'>
                              <div className="col-lg-5 col-sm-12 col-12 m-auto">  
                       <div className="login-box card">
                        <div className="card-body" style={{padding: 10}}>
                            <div className="form-horizontal form-material text-center" >
                            {!ForgotShow ?
                                <>
                                    <img src={curonext} className='img img-responsive img-fluid logo-width mt-0 mb-2'/>
                                    <div className="form-group">
                                        <div className="col-xs-12">
                                            <div className="label-float mb-3">
                                                <input type="text" style={{padding: 10}} onChange={(e) => {setEmailPhone(e.target.value)}} value={EmailPhone} />
                                                <label>Email / Mobile Number</label>
                                            </div>
                                            <div className="label-float">
                                                <input type="password" style={{padding: 10}} onChange={(e) => {setPassword(e.target.value)}} value={Password} />
                                                <input type="submit" onClick={LoginApi}  hidden />
                                                <label>Password</label>
                                            </div>
                                            <div className='label-float d-flex pt-0'>
                                            <div className="label-float mb-0 pt-0 pr-2">
                                                    <input type="text" style={{padding: "8px"}} value={captchaInput} onChange={(e) => setCaptchaInput(e.target.value)} required />
                                                    <label style={{top: "-14px", left: "6px", color: "#3951b2", lineHeight: "23px"}}>Enter Captcha</label>
                                                </div>
                                                <canvas ref={canvasRef} width="150" height="30" style={{ border: '1px solid #ccc' }}></canvas>
                                                <button type="button" className='btn btn-info btn-rounded' onClick={handleRefreshCaptcha}><FontAwesomeIcon icon={faRefresh} style={{color: "#fff"}} /> </button>
                                            </div>
                                            <div className="text-center">
                                                <div className="col-xs-12">
                                                    <button className="btn btn-block btn-lg btn-info btn-rounded text-white ml-0" disabled={Disable} onClick={LoginApi}>Log In</button>
                                                </div>
                                            </div>
                                            <h5 className='mt-2 mb-0 pb-0 text-right text-decoration-underline' style={{cursor: "pointer"}} onClick={() => {setForgotShow(true); setOTPShow(true); setForgotEmailPhone(""); setOTP(""); setDisableOTP(true); setDisableOTPMatch(true); setIsButtonDisabled(true)}}>Forgot Password ?</h5>
                                        </div>
                                    </div>
                                </>
                            :
                            
                                <div className="form-horizontal">
                                        <div className="form-group ">
                                            <div className="col-xs-12">
                                                <h3>Forgot Password</h3>
                                                <p className="text-muted">Enter your Email / Mobile Number and instructions will be sent to you! </p>
                                            </div>
                                        </div>
                                        <div className="label-float mb-3">
                                            <input type="text" style={{padding: 10}} onChange={(e) => {setForgotEmailPhone(e.target.value)}} value={ForgotEmailPhone} />
                                            <label>Email / Mobile Number</label>
                                        </div>
                                        {OTPShow ? 
                                            <div className="form-group text-center m-t-20">
                                                <div className="col-xs-12">
                                                    <button className="btn btn-block btn-lg btn-info btn-rounded text-white ml-0" disabled={DisableOTP} onClick={handleSendOtp}>Send OTP</button>
                                                </div>
                                            </div>
                                        :    
                                        <>
                                            <div className="label-float mb-3">
                                                <input type="text" style={{padding: 10}} onChange={(e) => {setOTP(e.target.value)}} value={OTP} />
                                                <label>Enter OTP</label>
                                            </div>

                                            <div className="form-group text-center m-t-20">
                                                <div className="col-xs-12">
                                                    <button className="btn btn-block btn-lg btn-info btn-rounded text-white ml-0" disabled={DisableOTPMatch} onClick={matchOTP}>Send</button>
                                                </div>
                                            </div>
                                        </>    }
                                        <div className='row'>
                                            <div className='col-6'>
                                                <h5 className='mt-2 mb-0 pb-1 text-left text-decoration-underline' style={{cursor: "pointer"}} onClick={() => {setForgotShow(false); setOTPShow(true); setForgotEmailPhone(""); setOTP(""); setDisableOTP(true); setDisableOTPMatch(true)}}>Login</h5>
                                            </div>
                                            <div className='col-6'>
                                                {!isButtonDisabled ?
                                                    <h5 className='mt-2 mb-0 pb-1 text-right text-decoration-underline' style={{cursor: "pointer"}} onClick={() => {handleSendOtp();}}>Resend OTP ?</h5>
                                                    :null}
                                            </div>
                                        </div>
                                </div>
                                }        
                               
                            </div>
                          
                        </div>
                    </div>
                    </div>
                        </div>
                    </div>

           
        </div>

       <p style={{color:'#ffffff', textAlign: 'center', marginTop: '-26px', marginBottom: '0px', fontWeight: '500'}}>  CuroNext © All Rights Reserved. {new Date().getFullYear()} </p>
            

       
            </>

            

    )
  }
  export default Login

